import { BaseSyntheticEvent } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { IOption, PartnerFormKeyNames, AgentFormKeyNames, UniStaffFormKeyNames } from 'api-paths-cas';
import { IUniStaffRegistrationForm } from './useUniForm';
import { IProviderRegistrationForm } from './usePartnerForm';
import { IAgentRegistrationForm } from './useAgentForm';

export interface UseApplicationFormReturnType<
  T extends IAgentRegistrationForm | IUniStaffRegistrationForm | IProviderRegistrationForm,
> {
  form: UseFormReturn<T, unknown>;
  uniOptions: IOption[];
  onSubmit: (e?: BaseSyntheticEvent) => Promise<void>;
  clearDependentFields: (fields: string[]) => void;
}

export const initialPartnerFormValues = {
  [PartnerFormKeyNames.EMAIL]: '',
  [PartnerFormKeyNames.PREFERRED_NAME]: '',
  [PartnerFormKeyNames.MOBILE_NUMBER]: '',
  [PartnerFormKeyNames.NATIONALITY]: '',
  [PartnerFormKeyNames.DOB]: '',
  [PartnerFormKeyNames.UNIVERSITY_ID]: '',
  [PartnerFormKeyNames.INTAKE_ID]: '',
  [PartnerFormKeyNames.STUDY_LEVEL]: '',
  [PartnerFormKeyNames.FEE_STATUS]: '' as any,
  [PartnerFormKeyNames.COURSE_NAME]: '',
  [PartnerFormKeyNames.COURSE_ID]: '',
  [PartnerFormKeyNames.MODE]: '',
  [PartnerFormKeyNames.CAMPUS]: '',
  [PartnerFormKeyNames.ENTRY_POINT]: '',
  [PartnerFormKeyNames.PROGRAMME_CHOICES]: [],
};

export const initialUniStaffFormValues: Required<IUniStaffRegistrationForm> = {
  [UniStaffFormKeyNames.EMAIL]: '',
  [UniStaffFormKeyNames.PREFERRED_NAME]: '',
  [UniStaffFormKeyNames.MOBILE_NUMBER]: '',
  [UniStaffFormKeyNames.NATIONALITY]: '',
  [UniStaffFormKeyNames.DOB]: '',
  [UniStaffFormKeyNames.UNIVERSITY_ID]: '',
  [UniStaffFormKeyNames.INTAKE_ID]: '',
  [UniStaffFormKeyNames.STUDY_LEVEL]: '',
  [UniStaffFormKeyNames.FEE_STATUS]: '' as any,
  [UniStaffFormKeyNames.COURSE_NAME]: '',
  [UniStaffFormKeyNames.COURSE_ID]: '',
  [UniStaffFormKeyNames.MODE]: '',
  [UniStaffFormKeyNames.CAMPUS]: '',
  [UniStaffFormKeyNames.ENTRY_POINT]: '',
  [UniStaffFormKeyNames.PROGRAMME_CHOICES]: [],
  [UniStaffFormKeyNames.DISABLE_EMAIL_NOTIFICATIONS]: true,
};

export const initialAgentFormValues = {
  [AgentFormKeyNames.EMAIL]: '',
  [AgentFormKeyNames.PREFERRED_NAME]: '',
  [AgentFormKeyNames.MOBILE_NUMBER]: '',
  [AgentFormKeyNames.NATIONALITY]: '',
  [AgentFormKeyNames.DOB]: '',
  [AgentFormKeyNames.UNIVERSITY_ID]: '',
  [AgentFormKeyNames.INTAKE_ID]: '',
  [AgentFormKeyNames.STUDY_LEVEL]: '',
  [AgentFormKeyNames.FEE_STATUS]: '' as any,
  [AgentFormKeyNames.COURSE_NAME]: '',
  [AgentFormKeyNames.COURSE_ID]: '',
  [AgentFormKeyNames.MODE]: '',
  [AgentFormKeyNames.CAMPUS]: '',
  [AgentFormKeyNames.ENTRY_POINT]: '',
  [AgentFormKeyNames.AGENT_CONSENT]: false,
  [PartnerFormKeyNames.PROGRAMME_CHOICES]: [],
};
